import { AbstractControl, ValidationErrors } from '@angular/forms';

export class WhiteSpaceValidator {

  static cannotStartWithEmptyString(control: AbstractControl): ValidationErrors | null {

    let start: boolean = control.value.startsWith(' ');

    return start ? { startEmptyString: true } : null;
  }

  static cannotFinishWithEmptyString(control: AbstractControl): ValidationErrors | null {

    let value: string = control.value;

    let end: boolean = value.endsWith(' ');

    return end ? { finishEmptyString: true } : null;
  }
}
